import { addCustomEventToDataLayer } from './index';
export function addStandardEvent(name, category, action, label) {
    const event = {
        event: name,
        eventInfo: {
            eventCategory: category,
            eventAction: action,
            eventLabel: label,
        }
    };
    addCustomEventToDataLayer(event);
}
export function addDeliveryComplaintStartedNew(statedFrom) {
    const event = {
        event: 'delivery_complaint_started_new',
        statedFrom: statedFrom
    };
    addCustomEventToDataLayer(event);
}
export function addDeliveryComplaintReasonSelected(selectedComplaintReason) {
    const event = {
        event: 'delivery_complaint_reason_selected',
        selectedComplaintReason: selectedComplaintReason
    };
    addCustomEventToDataLayer(event);
}
export function addDeliveryComplaintFinalizingComplaint(succeeded, selectedComplaintReason) {
    const event = {
        event: 'delivery_complaint_finalizing_complaint',
        succeeded: succeeded,
        selectedComplaintReason: selectedComplaintReason
    };
    addCustomEventToDataLayer(event);
}
export function addInventoryCountStarted(pantryIds) {
    const event = {
        event: 'inventorycount_started',
        pantryIds: pantryIds
    };
    addCustomEventToDataLayer(event);
}
export function addInventoryCountCompleted(pantryIds) {
    const event = {
        event: 'inventorycount_completed',
        pantryIds: pantryIds
    };
    addCustomEventToDataLayer(event);
}
export function addInventoryCountReOpened(pantryIds) {
    const event = {
        event: 'inventorycount_reopened',
        pantryIds: pantryIds
    };
    addCustomEventToDataLayer(event);
}
export function depositReturnStarted() {
    const event = {
        event: 'deposit_return_started'
    };
    addCustomEventToDataLayer(event);
}
export function depositReturnSelectedNewDate(returnDate) {
    const event = {
        event: 'deposit_return_selected_new_date',
        returnDate: returnDate
    };
    addCustomEventToDataLayer(event);
}
export function depositReturnItemChangedQuantity(newQuantity) {
    const event = {
        event: 'deposit_return_item_changed_quantity',
        newQuantity: newQuantity
    };
    addCustomEventToDataLayer(event);
}
export function depositReturnSubmit(returnDate, itemsToSubmit, depositReturnsTotal) {
    const event = {
        event: 'deposit_return_submit',
        returnDate: returnDate,
        itemsToSubmit: itemsToSubmit,
        depositReturnsTotal: depositReturnsTotal
    };
    addCustomEventToDataLayer(event);
}
